module.exports = __webpack_public_path__ + "img/20191216161725603.770cddf8.jpg";